import React, { useState, useEffect } from 'react';
import VerticalBarChart from '../components/VerticalBarChart';
import secureRemainingForecastSubsidiaryCompaniesService from './secure_remaining_forecast_subsidiary_companies.service';
const SecureRamainingForecastQESubsidiaryCompany = _ref => {
  let {
    filteredBusinessUnits,
    selectedYears,
    companyId,
    selectedSubsidiaryCompanyIds
  } = _ref;
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const businessUnitsParam = filteredBusinessUnits.map(bu => bu.business_unit_id).join(',');
        const yearsParam = selectedYears.join(',');
        const subsidiaryCompanyIdsParam = selectedSubsidiaryCompanyIds.join(',');
        const data = await secureRemainingForecastSubsidiaryCompaniesService.all(companyId, businessUnitsParam, yearsParam, subsidiaryCompanyIdsParam);
        const transformedData = Object.entries(data).map(_ref2 => {
          let [label, value] = _ref2;
          return {
            label,
            value: parseFloat(value)
          };
        });
        setChartData(transformedData);
      } catch (error) {
        console.error('Error fetching Secure QE forecast by subsidiary company:', error);
      }
    };
    fetchData();
  }, [companyId, filteredBusinessUnits, selectedYears, selectedSubsidiaryCompanyIds]);
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card dashboard-card-group-chart"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center dashboard-regular-card-title"
  }, "Secure QE (\xA3)"), /*#__PURE__*/React.createElement(VerticalBarChart, {
    data: chartData,
    groups: [],
    dataName: "Secure QE (\xA3)",
    showLabels: true,
    showLegend: false,
    colors: ['#00afef', '#0078b9', '#00b08b']
  }));
};
export default SecureRamainingForecastQESubsidiaryCompany;